var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "font-size-xlg"
  }, _vm._l(_vm.icons, function (icon, index) {
    return _c('span', {
      key: icon.iconName
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": icon.iconName,
        "title": icon.iconName
      }
    }), _vm._v("  "), (index + 1) % 10 === 0 ? _c('br') : _vm._e()], 1);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }